import Vue from 'vue'
import BootsrapVue from 'bootstrap-vue';
import { BVConfigPlugin } from 'bootstrap-vue';
import moment from 'moment';
import TerminologyService from '@/services/TerminologyService';
import VueCompositionAPI from '@vue/composition-api'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import 'vue-search-select/dist/VueSearchSelect.css';
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

extend('future_date', {
  validate(value) {
    if (!value) return false;
    const selectedDate = moment(value, 'YYYY-MM-DD');
    const today = moment().startOf('day');
    return selectedDate.isSameOrAfter(today);
  },
  message: 'End date must be today or in the future.',
});

extend('required', {
  validate(value) {
    return value !== null && value !== undefined && value !== '';
  },
  message: 'This field is required',
});

extend('prisonerNumberFormat', {
  validate(value) {
    if (!value) return false;
    const regex = /^[A-Z]{1}[0-9]{4}[A-Z]{2}$/i;
    return regex.test(value);
  },
  message: 'Prisoner number must be in the format A1234AA',
});

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// BSV Plugin Registration
Vue.use(BootsrapVue)

// Prevent modals from closing when clicking on backdrop or esc button
Vue.use(BVConfigPlugin, {
  BModal: {
    noCloseOnBackdrop: true,
    noCloseOnEsc: true,
  },
});

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.filter('formatDate', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY');
});

Vue.filter('formatDateShort', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YY');
});

Vue.filter('formatDateTime', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY HH:mm');
});

Vue.filter('capEachWord', value => {
  if (!value) return '';
  return value
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
});

Vue.filter('boolToYes', value => (value ? 'Yes' : 'No'));

Vue.filter('term', (word, capitalize = false) => {
  const establishment = store.state.auth.user.prison.establishment_type || 'prison';

  if (word === 'prison') {
    return TerminologyService.getEstablishmentTextForPrison(establishment, capitalize);
  } if (word === 'prisoner') {
    return TerminologyService.getEstablishmentTextForPrisoner(establishment, capitalize);
  }

  return '';
});

Vue.filter('formatDateAge', value => {
  if (!value) return '';
  return moment(new Date()).diff(value, 'years');
});

Vue.filter('splitCaps', value => {
  if (!value) return '';
  const parts = value.split(/(?=[A-Z])/);
  let text = '';
  parts.forEach(part => { text += `${part} ` });
  return text.trim();
});

Vue.filter('regionCurrency', () => {
  const region = store.state.region || 'UK';

  if (region === 'UK'){
    return '£';
  }
  return '$'; // Australia
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
